<template>
	<!-- Magical Vue transitions. Pretty sweet! -->
	<transition name="fade">
		<!-- Pretty simple, really. If the user is authenticated, show the app as normal. If not, don't. -->
		<div key="authenticated" id="app" v-if="isAuthenticated && authExceptions.indexOf($route.path) === -1">
			<!-- Our beautiful nav bar -->
			<Nav />

			<!-- Our router determines which component view is loaded. To make things look nicer, we also wrap it in a transition -->
			<transition name="fade">
				<router-view :key="'root-' + $route.path" v-if="$route.name !== 'register'"></router-view>
			</transition>

			<!-- The footer -->
			<Footer />

			<!-- A global modal component to show universal messages -->
			<GlobalModal />
		</div>
		<!-- The view we show for those who are not logged in -->
		<div key="unauthenticated" id="app" v-else>
			<transition name="fade">
				<router-view v-if="authExceptions.indexOf($route.path) !== -1" :key="'root-' + $route.path"></router-view>
				<Unauthenticated v-else :is-loading="isLoading" />
			</transition>
		</div>
	</transition>
</template>

<script>
// @ is an alias to /src
import Unauthenticated from '@/components/App/Unauthenticated/index';
import Nav from '@/components/App/Nav/index';
import Footer from '@/components/App/Footer/index';
import GlobalModal from '@/components/App/GlobalModal/index';

export default {
	data() {
		return {
			isLoading: true,
			isAuthenticated: false,
			authExceptions: ['/login', '/register', '/reset-password']
		};
	},
	methods: {
		handleLoginEvent(data) {
			this.isAuthenticated = data.loggedIn;
		}
	},
	watch: {
		async isAuthenticated(newVal) {
			// If the user is logged in, try to grab their first store and use it to get product classes for their price level
			if (newVal === true) {
				// If logged in, re-route user to home page
				if (this.$route.name === 'register') {
					this.$router.replace({ name: 'home' });
				}
			}
		}
	},
	components: {
		Unauthenticated,
		Nav,
		Footer,
		GlobalModal
	},
	async created() {
		const error = await this.$auth.renewToken();

		if (error) {
			// Redirect to the login URL if not logged in and not already on an unauthenticated page
			if (window.location.pathname !== '/' && this.authExceptions.indexOf(window.location.pathname) === -1) {
				const redirectPath = window.location.href.split(window.location.host)[1];
				this.$router.replace({ name: 'login', query: { redirect: redirectPath } });
			}
		}

		// Be sure to remove the loading screen
		this.isLoading = false;
	}
};
</script>

<style lang="scss">
body {
	background: $brand-white;
	margin: 0;
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-weight: 500;
	}
}

// Classes for defining magical Vue transitions!
// Always follows the pattern of {transition name}-{transition state name}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
